import moment from 'moment';
import { APP_INIT } from '../helpers/serverRenderingUtils';
import { unsetAndRedirectUser } from './user';

export const CLEAR_PODCAST_ANALYTICS =
  '@@podcastAnalytics/CLEAR_PODCAST_ANALYTICS';
export const RECEIVE_ALL_TIME_PODCAST_EPISODE_DOWNLOADS =
  '@@podcastAnalytics/RECEIVE_ALL_TIME_PODCAST_EPISODE_DOWNLOADS';
export const RECEIVE_DATE_RANGE_BUTTON_SELECT =
  '@@podcastAnalytics/RECEIVE_DATE_RANGE_BUTTON_SELECT';

const emptyObject = {};

export const MAX_NUMBER_UNITS = 300;

// 'past 6 months'
const { weekEnd, weekStart } = generateLastSixMonthsDateRange();
export const DEFAULT_DATE_RANGE_START = weekStart;
export const DEFAULT_DATE_RANGE_END = weekEnd;

const initialState = {
  allTimePodcastDownloads: emptyObject,
  dateRangeEnd: DEFAULT_DATE_RANGE_END,
  dateRangeStart: DEFAULT_DATE_RANGE_START,
  selectedDateButton: null,
};

// reducers

function reducer(state = initialState, action) {
  switch (action.type) {
    case APP_INIT: {
      const { dateRangeEnd, dateRangeStart } = state;
      return {
        ...state,
        dateRangeEnd: dateRangeEnd ? new Date(dateRangeEnd) : null,
        dateRangeStart: dateRangeStart ? new Date(dateRangeStart) : null,
      };
    }
    case CLEAR_PODCAST_ANALYTICS: {
      return initialState;
    }
    case RECEIVE_ALL_TIME_PODCAST_EPISODE_DOWNLOADS: {
      return {
        ...state,
        allTimePodcastDownloads: action.payload,
      };
    }
    case RECEIVE_DATE_RANGE_BUTTON_SELECT: {
      const { selectedDateButton } = action.payload;
      return {
        ...state,
        selectedDateButton,
      };
    }
    default:
      return state;
  }
}

// action creators

export function clearPodcastGraphAnalytics() {
  return {
    type: CLEAR_PODCAST_ANALYTICS,
  };
}

function receiveAllTimePodcastEpisodeDownloads({ ct = 0, averageCt = 0 }) {
  return {
    type: RECEIVE_ALL_TIME_PODCAST_EPISODE_DOWNLOADS,
    payload: {
      count: ct,
      averageCount: averageCt,
    },
  };
}

export function receiveDateRangeButtonSelect(selectedDateButton) {
  return {
    type: RECEIVE_DATE_RANGE_BUTTON_SELECT,
    payload: {
      selectedDateButton,
    },
  };
}

// thunks
export function fetchMyAllTimePodcastDownloads() {
  return async dispatch => {
    try {
      const response = await fetch('/api/podcast/analytics/downloads/all', {
        credentials: 'same-origin',
      });
      switch (response.status) {
        case 200: {
          const json = await response.json();
          dispatch(receiveAllTimePodcastEpisodeDownloads(json || {}));
          break;
        }
        case 401:
          dispatch(unsetAndRedirectUser());
          break;
        default:
          throw new Error(
            `Unable to fetchMyAllTimePodcastDownloads. Unexpected response: ${response.status}`
          );
      }
    } catch (err) {
      throw new Error(err.message);
    }
  };
}

function generateLastSixMonthsDateRange() {
  const weekEnd = moment()
    .startOf('day')
    .toDate();
  const weekStart = moment()
    .subtract(6, 'months')
    .toDate();
  return {
    weekEnd,
    weekStart,
  };
}

export default reducer;
